/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.cartElement = document.querySelector('cart-form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.qtyInput = this.querySelector('[data-qty-input]');
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  updateProductDetails(container, variant) {
    (variant == false) ? this.toggleAddButton('disable') : this.toggleAddButton('enable', variant.available);
    if(variant){
      this.updateURLandID(variant);
      this.priceUpdate(container, variant);
      this.updateImage(container, variant.featured_media);
    }
  }

  /**
   * Render Price details based on current variant
   */
   priceUpdate(container,variant){
    const priceElement = container.querySelector('[data-currentPrice]');
    if(!priceElement) return;
    
    const comparePriceElement = container.querySelector('[data-comparePrice]');
    priceElement.textContent = Utility.formatMoney(variant.price, window.globalSpace.money_format);
    if (comparePriceElement) {
      comparePriceElement.textContent = Utility.formatMoney(variant.compare_at_price, window.globalSpace.money_format);
      comparePriceElement.classList.toggle('d-none', !variant.compare_at_price || variant.compare_at_price <= 0 || variant.compare_at_price === variant.price);
    }
    if (variant.compare_at_price) {
      priceElement?.classList.add('text-red');
    } else {
      priceElement?.classList.remove('text-red');
    }
  }


  /**
     * Toggle the button based on product availability ( add to cart / soldOut )
     * @param {Text} status enable / disable
     * @param {Boolean} variantAvailable true/false
     */
   toggleAddButton(status, variantAvailable) {
    if (!this.submitButton) return;

    const addText = this.submitButton.querySelector('.add-text');
    if (status === 'disable' || (!variantAvailable)) {
        this.submitButton.setAttribute('disabled', true);
        if (addText) addText.textContent = status === 'disable' ? window.variantStrings.unavailable : window.variantStrings.soldOut;
    } else {
        this.submitButton.removeAttribute('disabled');
        if (addText) addText.textContent = this.form.classList.contains('cart-upsell-form') ? window.variantStrings.upsellAddText : window.variantStrings.addToCart;
    }
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant || !this.form) return;

    if (this.dataset.format === 'product-page') window.history.replaceState({}, '', `${this.form.dataset.url}?variant=${currentVariant.id}`);
    this.form.querySelector('input[name="id"]').value = currentVariant.id;
  }

  /**
   * Render selected variant image/slide
   * @param {element} container
   * @param {object} variantMedia
   */
  updateImage(container, variantMedia) {
    if(!variantMedia) return;

    const imgElem = container.querySelector('[data-feauredImage]');
    const imageSlide = container.querySelector(`[data-productSlider] [data-mediaID="${variantMedia.id}"]`);
    if (imgElem && variantMedia.preview_image.src) {
      imgElem.removeAttribute('srcset');
      imgElem.src = variantMedia.preview_image.src;
    } else if(imageSlide) {
      const slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      container.querySelector('[data-productSlider]').swiper.slideTo(slideIndex, 0, false);
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();

    const addItems = [];
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    addItems.push(Utility.serializeForm(this.form));
    let cartSectionID = 'component-cart-drawer';
    if(window.globalSpace.template == 'cart'){
      cartSectionID = document.getElementById('cart--items')?.dataset.id || 'template-cart';
    }

    const body = JSON.stringify({
      items: addItems,
      sections: `${cartSectionID},header` 
    });

    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      const dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      eventBus.publish(PUB_SUB_EVENTS.productATC, {
        data: {
          item: dataJSON.items[0]
        },
      });
      document.querySelector('#PopupModal-quickshop .close-quickshop')?.dispatchEvent(new Event('click'))

      if(this.qtyInput) this.qtyInput.value = 1;
      if(this.cartElement){
        this.cartElement?._updateCart(dataJSON.sections, this.submitButton);
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
    });
  }
}
customElements.define('product-form', ProductForm);
